import { render, staticRenderFns } from "./AdicionarItemAoReciboDialog.vue?vue&type=template&id=37577bb1&"
import script from "./AdicionarItemAoReciboDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarItemAoReciboDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports